<template>
  <a v-if="variant === 'program'" :href="to" class="navbar-recommendation-card">
    <b-img-lazy
      :src="cardAvatar"
      alt="recommendation-image"
    ></b-img-lazy>
    <div class="navbar-recommendation-text">
      <h3 class="title font-label-md-sb-lh24 mb-1">{{ title }}</h3>
      <div class="subtitle font-label-sm-rg">Oleh <span class="font-label-sm-sb">{{ creator }}</span></div>
    </div>
  </a>
  <router-link v-else-if="variant === 'institution'" :to="to" target="_self" class="navbar-recommendation-card">
    <b-img-lazy :src="`${urlServerImage}/72x52,fit/${avatar}`" alt="recommendation-image"></b-img-lazy>
    <div class="navbar-recommendation-text">
      <h3 class="title font-label-md-sb-lh24 mb-1">{{ title }}</h3>
      <div v-if="programCount" class="subtitle font-label-sm-rg"><span class="font-label-sm-sb">{{ programCount }}</span> Program Aktif</div>
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    avatar: String,
    title: String,
    creator: String,
    programCount: Number,
    to: String,
    variant: {
      type: String,
      default: 'program'
    }
  },
  computed: {
    urlServerImage () {
      return process.env.VUE_APP_URL_SERVER_IMAGE
    },
    cardAvatar () {
      return this.avatar
        ? `${this.urlServerImage}/72x52,fit/${this.avatar}`
        : `${this.urlServerImage}/72x52,fit/https://cdn.karier.mu/assets/cover/cover-thumbnail-semua-jenjang-236x228.jpg`
    }
  }
}
</script>

<style scoped>
.navbar-recommendation-card {
  position: relative;
  left: -24px;
  width: calc(100% + 48px);
  display: flex;
  align-items: center;
  gap: 17px;
  padding: 16px 24px;
  color: var(--color-text-primary);
}

.navbar-recommendation-card > img {
  border-radius: 5px;
  width: 72px;
  height: 48px;
  object-fit: contain;
  flex: none;
}

.navbar-recommendation-text > .title {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.navbar-recommendation-text > .subtitle {
  color: var(--color-ui-text-placeholder)
}

.navbar-recommendation-card:hover {
  background-color: var(--color-neutral-300);
  text-decoration: none;
}
</style>
